import React from 'react';
import Home from './Home/Home';


const main = () => {
    return <Home />
}

export default main;